import { Injectable } from "@angular/core";
import { Observable, catchError, of, tap } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DialogShareInWebDesktopComponent } from "@app/presentation/components/dialog-share-in-web-desktop/dialog-share-in-web-desktop.component";

@Injectable({ providedIn: "root" })
export class ShareMessageDesktopWeb {
  constructor(private modalService: NgbModal) {}

  execute(message: string, url: string): Observable<string> {
    let shareData = {
      title: "",
      text: message,
      url: url,
    };
    //In the future here we'll
    return of("").pipe(
      tap(() => this.#openShareDialog(message, url)),
      catchError((err) => of("error not catched"))
    );
  }

  #openShareDialog(message: string, url: string) {
    const ref = this.modalService.open(DialogShareInWebDesktopComponent, {
      centered: true,
    });
    ref.componentInstance.data = {
      message: message,
      url: url,
    };
  }
}
